module.exports = __webpack_public_path__ + "static/media/zamorak-general.27d9a88c.png";